import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {PartnerSummaryConverter} from '../../../../../partner/common/api/converter/partnerSummary.converter';
import {MedicalRecordPainModel} from '../model/medicalRecordPain.model';
import {CustomDateConverter} from '../../../../../common/custom-date/entity/converter/custom-date.converter';
import {MedicalRecordPainIntensityConverter} from './medicalRecordPainIntensity.converter';
import {DateConverter} from '../../../../../common/converter/date.converter';
import {
    LovValueOrCustomValueConverter
} from '../../../../../common/lov/lov-value/api/converter/LovValueOrCustomValue.converter';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class MedicalRecordPainConverter extends HttpModelConverter<MedicalRecordPainModel>{

    constructor(private lovValueOrCustomValueConverter: LovValueOrCustomValueConverter) {
        super();
    }

    protected createInstance(): MedicalRecordPainModel {
        return new MedicalRecordPainModel();
    }

    protected enrichObject(result: MedicalRecordPainModel, src: MedicalRecordPainModel) {
        const  customDateConverter: CustomDateConverter = new CustomDateConverter();
        result.partner = new PartnerSummaryConverter().convert(src.partner);
        result.locations = this.lovValueOrCustomValueConverter.convertFromArray(src.locations);
        result.whens = this.lovValueOrCustomValueConverter.convertFromArray(src.whens);
        result.hows = this.lovValueOrCustomValueConverter.convertFromArray(src.hows);
        result.from = customDateConverter.convert(src.from);
        result.to = customDateConverter.convert(src.to);
        result.intensities = new MedicalRecordPainIntensityConverter().convertFromArray(src.intensities);
        result.createdAt = new DateConverter().convert(src.createdAt);
        result.date = new DateConverter().convert(src.date);
    }
}
